import type { StatTileProps } from "./contract";
import styles from "./StatTile.module.css";

// 수치 한 개를 표시하는 타일이다. 값은 이미 포맷된 문자열로 들어온다. 타일은 단위를 모른다.
// `hint`·`ratio`(meter)는 기본적으로 값 아래가 아니라 **우측 보조 블록**에 둔다. 아래로 쌓으면
// 그 타일만 높아지고, 한 줄의 다섯 타일이 가장 높은 타일을 따라 늘어난다(타일은 grid stretch).
// 한 줄의 타일이 모두 긴 hint 를 가지는 화면은 `hintPlacement="below"` 를 쓴다.
export function StatTile({
  label,
  value,
  hint,
  ratio,
  emphasis = false,
  hintPlacement = "side",
}: StatTileProps) {
  const percent = ratio === undefined ? null : Math.round(Math.min(1, Math.max(0, ratio)) * 100);
  const hasSide = hint !== undefined || percent !== null;
  return (
    <div className={tileClassName(emphasis, hintPlacement)}>
      <span className={styles.label}>{label}</span>
      <div className={hintPlacement === "below" ? styles.contentStacked : styles.content}>
        <span className={styles.value}>{value}</span>
        {hasSide && (
          <div className={styles.side}>
            {hint !== undefined && <span className={styles.hint}>{hint}</span>}
            {percent !== null && (
              <div
                className={styles.meterTrack}
                role="progressbar"
                aria-label={`${label} ${percent}%`}
                aria-valuenow={percent}
                aria-valuemin={0}
                aria-valuemax={100}
              >
                <div className={styles.meterFill} style={{ width: `${percent}%` }} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function tileClassName(emphasis: boolean, hintPlacement: "side" | "below"): string {
  const names = [styles.tile];
  if (emphasis) {
    names.push(styles.emphasis);
  }
  if (hintPlacement === "below") {
    names.push(styles.stacked);
  }
  return names.join(" ");
}
